import { Box, Center, Spinner } from '@agrotoken-tech/ui';
import { useToastsHook, useTranslation } from '@bcba/react-hooks';
import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import { EquityInfoForm } from './EquityInfoForm';
import { FC } from 'react';
import { CompanyEquityInformationSerializer } from '@bcba/serializers';

interface Props {
  data: CompanyEquityInformationSerializer | undefined;
  isPending: boolean;
  refetch: (
    options?: RefetchOptions | undefined,
  ) => Promise<QueryObserverResult<CompanyEquityInformationSerializer, Error>>;
  isError: boolean;
}
export const EquityInfoSection: FC<Props> = ({
  data,
  isPending,
  refetch,
  isError,
}) => {
  const { t } = useTranslation();
  const { showErrorToast } = useToastsHook();

  if (isError) showErrorToast({ title: t('common.toast.error.title') });

  if (isPending || !data)
    return (
      <Center mt="8">
        <Spinner />
      </Center>
    );
  return (
    <Box maxW="868px">
      <EquityInfoForm data={data} refetch={refetch} />;
    </Box>
  );
};

export default EquityInfoSection;
